import React from 'react';
import * as PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Helmet from 'react-helmet';
import { parse as parseUrl } from 'url';
import { connect } from '../../connect';
import { FaithlifeFamilySites } from '../../components/faithlife-family-sites';
import { SignInForm } from '../../components/sign-in-form';
import { createJoinGroupMembership, createFollowGroupMembership } from '../../actions';
import logger from '../../utils/logger';
import '../../styles/sign-in-register.less';
import { formatUrl } from '../../utils/url';
import { IAuthState } from '../../reducers/auth-reducers';
import { IReduxProps } from '../../actions/action-types';

function mapStateToProps({ auth }, { location: { search } }) {
	const { returnUrl } = parseUrl(search, true).query;
	return { auth, returnUrl };
}

interface ISignInPageProps extends IReduxProps {
	auth: IAuthState;
	location: URL;
	returnUrl?: string;
}

@connect(mapStateToProps)
export default class SignInPage extends React.Component<ISignInPageProps> {
	static contextTypes = {
		router: PropTypes.object.isRequired,
	};

	componentDidMount() {
		const {
			location: { search },
			auth,
			returnUrl,
		} = this.props;
		const { redirectUrl } = parseUrl(search, true).query;
		const el = document.getElementById('app');
		if (el) {
			el.classList.add('SignInPage');
		}

		if (auth.user.id !== '-1') {
			this.context.router.history.push(returnUrl || redirectUrl || '/');
		}
	}

	componentWillReceiveProps(nextProps: ISignInPageProps) {
		let returnPath = this.props.returnUrl || '/';
		const {
			auth: nextAuth,
			location: { search: nextSearch },
			dispatch,
		} = nextProps;
		if (!nextAuth.isProcessing && nextAuth.user && nextAuth.user.id !== '-1') {
			if (nextSearch) {
				const { groupMembershipId: groupId, groupMembershipAction: action, redirectUrl } = parseUrl(
					nextSearch,
					true
				).query;

				if (groupId && action === 'join') {
					dispatch(createJoinGroupMembership(groupId, true)).catch(logger.error);
				} else if (groupId && action === 'follow') {
					dispatch(createFollowGroupMembership(groupId, true)).catch(logger.error);
				}

				if (redirectUrl) {
					if (Array.isArray(redirectUrl)) {
						returnPath = redirectUrl[0];
					} else {
						returnPath = redirectUrl;
					}
				}
			}
			this.context.router.history.push(returnPath);
		}
	}

	componentWillUnmount() {
		const el = document.getElementById('app');
		if (el) {
			el.classList.remove('SignInPage');
		}
	}

	_createUrl(baseUrl: string) {
		let url = baseUrl;
		const {
			location: { search },
		} = this.props;
		if (search) {
			const query = parseUrl(search, true).query;
			url = formatUrl(url, query);
		}
		return url;
	}

	render() {
		const url = this._createUrl('/register');

		return (
			<div className="sign-in-page">
				<Helmet title="Sign In" />
				<div className="background" />
				<div className="container">
					<div className="centered">
						<h2 className="centered-title">Sign In</h2>
						<FaithlifeFamilySites />
						<SignInForm location={this.props.location} className="centered" />
						<div className="centered-forgot-password-text">
							<Link to="/forgotpassword">Forgot Password?</Link>
						</div>
						<div className="centered-bottom-text">
							<Link to={url}>Create a free account</Link>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
